import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import { BookingStoreService } from '../../store/booking.store.service';
import { Booking } from '../../models/booking';
import {has} from "lodash";

@Injectable()
export class BookingResolver implements Resolve<Booking> {
  constructor(private bookingStoreService: BookingStoreService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Booking> {
    const bookingId = route.paramMap.get('id');
    if (bookingId) {
      return this.bookingStoreService.getBookingById(bookingId).pipe(
        tap((booking) => {
          if (!booking) {
            this.bookingStoreService.fetchBookingById(bookingId);
          }
        }),
        first((booking) => has(booking,'id'))
      );
    } else {
      return of(null);
    }
  }
}
